export const formatDuration = (centiseconds: number): string => {
  const safe = Math.max(0, centiseconds);
  const cs = Math.floor(safe % 100);
  const ss = Math.floor((safe / 100) % 60);
  const mm = Math.floor(safe / 6000);

  // Adicione zeros à esquerda se necessário
  const formattedSS = ss < 10 ? `0${ss}` : ss;
  const formattedMM = mm < 10 ? `0${mm}` : mm;
  const formattedCS = cs < 10 ? `0${cs}` : cs;

  return `${formattedMM}:${formattedSS}:${formattedCS}`;
};